<template>
  <div class="flex-col org-main">
    <div class="div-top">
      <div class="collapse-all"
        @click="collapseAll()">
        一键收起
      </div>
      <i class="iconfont iconCommunity"
        style="font-size: 0.875rem; color: #d04a02"></i>
      <div id="contractor-company-group-filter"
        class="filter"
        @click="showSearch">
        <span>{{ $t("common.filter") }} </span>
        <i class="iconfont iconfilter-outline"></i>
      </div>
      <van-popup v-model="showSearchPanel"
        position="right"
        :style="{ height: '100%', width: '80%' }">
        <search-panel :type="searchPanelType"
          @search="searchByPanel"></search-panel>
      </van-popup>
    </div>
    <div class="cont-list"
      id='company-group'>
      <van-list v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <van-collapse v-model="activeNames">
          <template v-for="company in list">
            <contractor-group-list-item-company :company="company"
              :key="company.companyName"></contractor-group-list-item-company>
          </template>
        </van-collapse>
      </van-list>
    </div>
  </div>
</template>

<script>
import ContractorGroupListItemCompany from "./ContractorGroupListItemCompany";
import SearchPanel from "@components/common/SearchPanel";
import common from "@common/common";
import webService from "@network/webService";
import store from "@common/store";
import _ from 'lodash';

export default {
  name: "",
  data () {
    return {
      activeNames: [],
      disableSwipe: true,
      showPrefer: true,
      list: [],
      loading: false,
      finished: false,
      currentPage: 0,
      order: 6,
      orderOptions: [{
        text: "按关系深度降序",
        value: 6,
      },
        // {
        //     text: "按职务排序",
        //     value: 1,   
        // },
      ],
      showSearchPanel: false,
      searchPanelType: common.searchTypeEnum.contractorCompany,
      oldSearchModel: {
        Search: "",
        SearchType: common.relationshipSearchTypeEnum.PEContact,
        ResponsibilityIds: [],
        TitleIds: [],
        RelationDeepthIds: [],
      },
      showFilter: false,
    };
  },
  components: {
    ContractorGroupListItemCompany,
    SearchPanel,
  },
  props: {
    pageType: {
      type: Number,
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  mounted () {
    this.showFilter =
      this.pageType != common.searchTypeEnum.contractorHistory;
    this.disableSwipe =
      this.pageType != common.searchTypeEnum.contractorCompanyCollect;

    this.showPrefer =
      this.pageType != common.searchTypeEnum.contractorCompanyCollect;

    if (this.pageType == common.searchTypeEnum.contractorHistory) {
      this.order = 3;
      this.orderOptions = [{
        text: "按更新时间降序",
        value: 3,
      }];
    }
    //this.onLoad();
  },
  created () {
    // this.currentPage = 0;
    // this.list = [];
    // this.onLoad();
  },
  methods: {
    collapseAll () {
      this.activeNames = [];
    },
    changeOrder (val) {
      console.log("order", this.order);
      this.currentPage = 0;
      this.list = [];
      this.requestPageData();
    },
    onLoad () {
      if (this.currentPage == 0) {
        this.list = [];
      }
      this.requestPageData();
    },
    showSearch () {
      this.showSearchPanel = true;
    },
    searchByPanel (searchParams) {
      if (searchParams.hasFilter) {
        if (document.getElementById('contractor-company-group-filter')) {
          document.getElementById('contractor-company-group-filter').classList.add('has-filter');
        }
      } else {
        if (document.getElementById('contractor-company-group-filter')) {
          document.getElementById('contractor-company-group-filter').classList.remove('has-filter');
        }
      }
      this.currentPage = 0;
      this.list = [];
      if (this.searchPanelType == common.searchTypeEnum.contractorCompany) {
        this.oldSearchModel.SearchType =
          common.relationshipSearchTypeEnum.PEContact;
        // this.oldSearchModel.ResponsibilityIds =
        //     searchParams.ResponsibilityIds;
        this.oldSearchModel.TitleIds = searchParams.TitleIds;
        this.oldSearchModel.RelationDeepthIds =
          searchParams.RelationDeepthIds;
      }
      store.state.filter.companyRelatiohshipDeepthIds = this.oldSearchModel.RelationDeepthIds;
      this.showSearchPanel = false;
      console.log(searchParams);
      this.requestPageData();
    },
    getData (searchModel) {
      if (searchModel.hasFilter) {
        if (document.getElementById('contractor-company-group-filter')) {
          document.getElementById('contractor-company-group-filter').classList.add('has-filter');
        }
      } else {
        if (document.getElementById('contractor-company-group-filter')) {
          document.getElementById('contractor-company-group-filter').classList.remove('has-filter');
        }
      }
      this.currentPage = 0;
      this.list = [];
      if (!searchModel) {
        searchModel = {
          PageSize: 100,
          Page: 0,
          SearchType: common.relationshipSearchTypeEnum.PEContact,
        };
      } else if (
        this.searchPanelType == common.searchTypeEnum.contractorCompany
      ) {
        this.oldSearchModel = searchModel;
      }
      //web 数据请求
      this.requestPageData(true);
    },
    requestPageData (isFirst) {
      let searchModel = {
        PageSize: 16,
        Page: this.currentPage,
        SearchType: this.oldSearchModel.SearchType,
        Search: this.oldSearchModel.Search,
        // ResponsibilityIds: this.oldSearchModel.ResponsibilityIds,
        Positions: this.oldSearchModel.TitleIds,
        RelationDeepthIds: this.oldSearchModel.RelationDeepthIds,
        FavoriteType: common.favoriteTypeEnum.CompanyContact,
        OrderType: -1, //this.order,
      };

      webService.searchContractListGroupByCompany(searchModel).then((res) => {
        if (isFirst) {
          this.currentPage = 0;
          this.list = [];
        }
        common.procssData(this, res.data);
        this.list = _.uniqBy(this.list, 'companyName');
      });
    },
    selectAll () {
      this.list.forEach((element) => {
        element.checked = true;
      });
    },
    cancelSelected () {
      this.list.forEach((element) => {
        element.checked = false;
      });
    },
    deleteItem () {
      common.batchDeleteMarked(this);
    },
    cancelMark (id) {
      common.cancelMark(this, id);
    },
    changeSearchValue (value) {
      this.oldSearchModel.Search = value;
    }
  },
};
</script>

<style lang="less" scoped>
.org-main {
  height: 100%;
  display: flex;
  flex-direction: column;
  // border-top: 1px solid #dedede;
}

.div-top {
  display: flex;
  align-items: center;
  height: 2rem;
  padding: 0.375rem 0.625rem;

  /deep/ .van-dropdown-menu__bar {
    box-shadow: none;
  }

  .org-name {
    flex: 2;
    font-size: 14px;
    font-weight: bolder;
    color: #464646;
    margin-left: 0.375rem;
  }

  .filter {
    text-align: right;
    flex: 1;

    span {
      font-size: 0.875rem;
    }

    img {
      width: 1.25rem;
      vertical-align: middle;
    }
  }
}

.cont-list {
  overflow: auto;
  flex: 1;
  height: 100%;
}

// /deep/ .van-dropdown-menu__bar{
//   height: ;
// }
.van-collapse-item /deep/ .van-cell {
  background-color: #f8f8f8;
}

.van-collapse-item {
  /deep/ .item-main .item-info {
    padding: 0px;
  }
  /deep/ .van-collapse-item__content {
    //padding: 12px 0px;
    padding: 0 0 0px 0;
  }
}

.collapse-all {
  font-size: 0.875rem;
  padding-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/content/contractor/ContractorGroupListCompany.vue